import React from "react"

export const Eye = ({ size, fill = "fill-white", stroke = "" }) => {
  return (
    <svg
      className={`${size} ${fill} ${stroke}`}
      viewBox="0 0 27 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.5 2.61851C18.1514 2.61851 22.2995 5.40722 24.3245 9.8194C22.2995 14.2316 18.1514 17.0203 13.5 17.0203C8.84864 17.0203 4.70045 14.2316 2.67545 9.8194C4.70045 5.40722 8.84864 2.61851 13.5 2.61851ZM13.5 0C7.36364 0 2.12318 4.07178 0 9.8194C2.12318 15.567 7.36364 19.6388 13.5 19.6388C19.6364 19.6388 24.8768 15.567 27 9.8194C24.8768 4.07178 19.6364 0 13.5 0ZM13.5 6.54626C15.1936 6.54626 16.5682 8.01263 16.5682 9.8194C16.5682 11.6262 15.1936 13.0925 13.5 13.0925C11.8064 13.0925 10.4318 11.6262 10.4318 9.8194C10.4318 8.01263 11.8064 6.54626 13.5 6.54626ZM13.5 3.92776C10.4564 3.92776 7.97727 6.57245 7.97727 9.8194C7.97727 13.0663 10.4564 15.711 13.5 15.711C16.5436 15.711 19.0227 13.0663 19.0227 9.8194C19.0227 6.57245 16.5436 3.92776 13.5 3.92776Z" />
    </svg>
  )
}
